<template>
  <div
    v-click-outside="e => close(e)"
    class="csst underline-tooltip"
    @mouseleave="close()"
    @mouseenter="e => handleMouseenter(e)"
    @touchstart="e => handleMouseenter(e)"
  >
    <div
      :class="cssClass"
      class="underline-tooltip-container"
      :style="underlineStyle"
    >
      <slot />
      <transition name="fade">
        <span
          v-if="hasHelp"
          class="anim-fade-in_delayed_2s position-relative z-index_4"
        >
          <div class="underline-tooltip-help-box elevation-4">
            {{ $t('tooltips.hover_over') }}
          </div>
        </span>
      </transition>
    </div>
    <div
      v-if="open"
      :style="contentStyle"
      style="position: fixed"
      class="csst_content csst_content_hoverable f-column underline-tooltip-content anim-fade-in clr-white"
    >
      <img
        v-if="img"
        class="underline-tooltip-img mt-3"
        :src="getImage(img)"
      />
      <span
        class="underline-tooltip-text my-2 weight_500 text-left"
        v-html="text"
      >
      </span>
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'TooltipUnderline',
  mixins: [float_mix],

  props: {
    text: String,
    img: String,
    cssClass: String,
    hasHelp: Boolean,
    contentStyle: String,
    underlineStyle: String,
  },
  data() {
    return {
      open: false,
    }
  },
  methods: {
    close(e) {
      this.open = false
    },
    handleMouseenter(e) {
      this.open = true
      nextTick(() => {
        this.fl_positionTooltip(e, { offset: 0, padding: 0, placement: 'bottom' })
      })
    },
    getImage(img) {
      return new URL(`/src/assets/img/${img}`, import.meta.url).href
    },
  },
}
</script>

<style lang="scss" scoped>
.tooltip-no-underline {
  // border: solid red 2px;
  // .underline-tooltip-container {

  &::before {
    display: none;
  }
  // }
}
.underline-tooltip {
  position: relative;
}
.underline-tooltip-container {
  --underline-clr: currentColor;
  position: relative;
  text-decoration: underline;
  text-decoration-style: dotted;
  text-decoration-color: var(--underline-clr);
  // &:before {
  //   content: '';
  //   background-image: linear-gradient(90deg, currentColor 33%, transparent 0);
  //   background-position: bottom;
  //   background-repeat: repeat-x;
  //   background-size: 3px 1px;
  //   height: 1px;
  //   left: 0;
  //   position: absolute;
  //   top: 100%;
  //   width: 100%;
  // }
}

.has-underline {
  @extend .underline-tooltip-container;
}

.underline-tooltip-content {
  // max-width: calc(100vw - 4rem);
  // width: 100vw;
  max-width: clamp(12rem, 420px, 95vw);
  // min-width: 80px;
  .underline-tooltip-img {
    width: 100vw;
    max-width: clamp(12rem, calc(clamp(12rem, 420px, 95vw) - 1.5rem), 95vw);
    // max-width: calc(100vw - 4rem);
    border-radius: 4px;
  }
  .underline-tooltip-text {
    font-size: 1rem;
  }
}

.underline-tooltip-help-box {
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  background: var(--clr-grey-2);
  border-radius: 4px;
  font-weight: 500;
  padding: 1rem;
  white-space: nowrap;
  color: var(--clr-white-0);
  top: -0.7rem;
  left: calc(100% + 1.5rem);
  position: absolute;
  width: 24rem;
  animation: leftRight 2s infinite ease-in;
  &:after {
    content: '';
    position: absolute;
    left: -22px;
    top: 1rem;
    width: 0;
    height: 0;
    transform: rotate(90deg);
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    // border-top: 20px solid red;
    border-top: 20px solid var(--clr-grey-2);
    clear: both;
  }
}

@keyframes leftRight {
  0% {
    margin-left: -3px;
  }
  50% {
    margin-left: 3px;
  }
  100% {
    margin-left: -3px;
  }
}
</style>
